import apiRoutes from "../../utils/constants/apiRoutes";
import ApiService from "../apiService";
import handleApiCall from "../handleApi";

export const getOnboardingService = async () =>
  handleApiCall(() => ApiService.get(apiRoutes.onboarding));

export const getOnboardingByIdService = async (id: string) =>
  handleApiCall(() =>
    ApiService.get(apiRoutes.onboardingById.replace(":id", id))
  );
